import Vue from 'vue';
import type { PluginOptions } from 'vue-gtag';
import VueGtag from 'vue-gtag';
import type { Plugin } from '@nuxt/types';

/**
 * Note that this plugin is V1 and must remain in V1.
 * V2 is only compatible with Vue3.
 * @see [vue-gtagV1](https://matteo-gabriele.gitbook.io/vue-gtag/v/master/)
 */
const VueGtagPlugin: Plugin = (ctx, inject) => {
  Vue.use(VueGtag, {
    config: { id: 'AW-10888375321' } /** Google Ads */,
    includes: [{ id: process.env.isProduction ? 'G-E3CRSTVYMH' : 'G-G1QBZKPNB4' }] /** Google Analytics 4 */,
  } as PluginOptions);
  // @ts-ignore
  const gtag = Vue.$gtag;

  ctx.$gtag = gtag;
  inject('gtag', gtag);
};

export default VueGtagPlugin;
